import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { settingTransparency } from 'services/setting'

export default function useSetTransparency(refetch: () => void) {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingTransparencyPayload) => {
            return settingTransparency(payload)
        },
        onSuccess: (data) => {
            refetch()
            toast.success('تغییرات با موفقیت انجام شد')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
